/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * ServicePackageKindEnum
 * Mirror of the ``enum_service_package_kind`` Postgres type.
 *
 * Lowercase to match the database labels exactly, following
 * ``LinePricingModeEnum`` above.
 *
 * ``SIMPLE`` means the contents are a bag of services with a quantity each -
 * what a package is with no pattern drawn on it - and it is the column's
 * DEFAULT, so a caller that has never heard of templates keeps describing the
 * packages it always described. ``REPEATED`` places those same contents on a
 * weekly grid of untimed slots and carries a visit count, so the package
 * describes a shape of week as well as a bundle.
 *
 * A named enum rather than a set of literals for the reason the migration gives:
 * a monthly pattern is the obvious next kind, and adding it is one
 * ``ALTER TYPE ... ADD VALUE`` rather than a constraint rewrite.
 *
 * That buys the DATABASE a free extension - its CHECKs are one-directional, so a
 * third label needs no constraint rewritten. It does NOT buy one here:
 * :func:`_validate_kind_shape` gives every kind its own branch and RAISES on one
 * it does not know, so a label added by ``ALTER TYPE`` alone stops at this model
 * with "unhandled package kind" instead of being silently judged as ``simple``
 * and having its pattern rejected. Loud is the point: the cost the named enum
 * avoids is a migration, not the cross-field rules, and those have to be written
 * for each kind that exists.
 */
export enum ServicePackageKindEnum {
  Simple = 'simple',
  Repeated = 'repeated',
}

/** RentalRateUnitEnum */
export enum RentalRateUnitEnum {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

/** InventoryRecipientTypeEnum */
export enum InventoryRecipientTypeEnum {
  Client = 'client',
  Caregiver = 'caregiver',
  External = 'external',
  Internal = 'internal',
}

/** InventoryMovementTypeEnum */
export enum InventoryMovementTypeEnum {
  Purchase = 'purchase',
  Sale = 'sale',
  Give = 'give',
  RentalOut = 'rental_out',
  RentalReturn = 'rental_return',
  Adjustment = 'adjustment',
}

/** ActiveRental */
export interface ActiveRental {
  /** Rentaloutid */
  rentalOutId: number;
  /** Itemid */
  itemId: number;
  /** Itemname */
  itemName?: string | null;
  /** Quantity */
  quantity: number;
  recipientType?: InventoryRecipientTypeEnum | null;
  /** Recipientid */
  recipientId?: number | null;
  /** Recipientname */
  recipientName?: string | null;
  /** Rentalstart */
  rentalStart?: string | null;
  /** Rentalexpectedreturn */
  rentalExpectedReturn?: string | null;
  /** Effectiveend */
  effectiveEnd?: string | null;
  /**
   * Isreturned
   * @default false
   */
  isReturned?: boolean;
  /** Createdat */
  createdAt?: string | null;
}

/** ActiveRentalListResponse */
export interface ActiveRentalListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ActiveRental[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** Body_importServicePackagesCommit */
export interface BodyImportServicePackagesCommit {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** Body_importServicePackagesPreview */
export interface BodyImportServicePackagesPreview {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** Body_importServicesCommit */
export interface BodyImportServicesCommit {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** Body_importServicesPreview */
export interface BodyImportServicesPreview {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Update
   * @default false
   */
  update?: boolean;
}

/** ExportColumnRequest */
export interface ExportColumnRequest {
  /** Key */
  key: string;
  /** Header */
  header: string;
}

/** ExportRequest */
export interface ExportRequest {
  /** Format */
  format: 'csv' | 'xlsx';
  /**
   * Columns
   * @maxItems 200
   * @minItems 1
   */
  columns: ExportColumnRequest[];
  /** Params */
  params?: Record<string, any>;
}

/** ExportStarted */
export interface ExportStarted {
  /** Exportid */
  exportId: number;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImportCounts */
export interface ImportCounts {
  /**
   * Create
   * @default 0
   */
  create?: number;
  /**
   * Update
   * @default 0
   */
  update?: number;
  /**
   * Skip
   * @default 0
   */
  skip?: number;
  /**
   * Errors
   * @default 0
   */
  errors?: number;
  /**
   * Warnings
   * @default 0
   */
  warnings?: number;
}

/** ImportIssue */
export interface ImportIssue {
  /** Sheet */
  sheet: string;
  /** Row */
  row?: number | null;
  /** Column */
  column?: string | null;
  /** Message */
  message: string;
  /**
   * Level
   * @default "error"
   */
  level?: 'error' | 'warning';
}

/** ImportReport */
export interface ImportReport {
  /**
   * Committed
   * @default false
   */
  committed?: boolean;
  counts: ImportCounts;
  /** Rows */
  rows: ImportRowResult[];
  /** Issues */
  issues: ImportIssue[];
}

/** ImportRowResult */
export interface ImportRowResult {
  /** Sheet */
  sheet: string;
  /** Row */
  row: number;
  /** Label */
  label: string;
  /** Action */
  action: 'create' | 'update' | 'skip' | 'error';
}

/** InventoryCategory */
export interface InventoryCategory {
  /** Categoryid */
  categoryId: number;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/** InventoryCategoryCreate */
export interface InventoryCategoryCreate {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
}

/** InventoryCategoryListResponse */
export interface InventoryCategoryListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: InventoryCategory[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** InventoryCategoryUpdate */
export interface InventoryCategoryUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/** InventoryItem */
export interface InventoryItem {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Categoryid */
  categoryId?: number | null;
  /** Code */
  code?: string | null;
  /** Unit */
  unit: string;
  /**
   * Isconsumable
   * @default false
   */
  isConsumable?: boolean;
  /**
   * Issellable
   * @default false
   */
  isSellable?: boolean;
  /**
   * Isrentable
   * @default false
   */
  isRentable?: boolean;
  /** Defaultcost */
  defaultCost?: number | null;
  /** Defaultsaleprice */
  defaultSalePrice?: number | null;
  /** Defaultrentalrate */
  defaultRentalRate?: number | null;
  defaultRentalRateUnit?: RentalRateUnitEnum | null;
  /** Reorderthreshold */
  reorderThreshold?: number | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
  /** Itemid */
  itemId: number;
  /**
   * Onhand
   * @default 0
   */
  onHand?: number;
  /**
   * Lowstock
   * @default false
   */
  lowStock?: boolean;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Hasdefaultcost */
  hasDefaultCost: boolean;
  /** Hasdefaultsaleprice */
  hasDefaultSalePrice: boolean;
  /** Hasdefaultrentalrate */
  hasDefaultRentalRate: boolean;
}

/** InventoryItemCreate */
export interface InventoryItemCreate {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Categoryid */
  categoryId?: number | null;
  /** Code */
  code?: string | null;
  /** Unit */
  unit: string;
  /**
   * Isconsumable
   * @default false
   */
  isConsumable?: boolean;
  /**
   * Issellable
   * @default false
   */
  isSellable?: boolean;
  /**
   * Isrentable
   * @default false
   */
  isRentable?: boolean;
  /** Defaultcost */
  defaultCost?: number | string | null;
  /** Defaultsaleprice */
  defaultSalePrice?: number | string | null;
  /** Defaultrentalrate */
  defaultRentalRate?: number | string | null;
  defaultRentalRateUnit?: RentalRateUnitEnum | null;
  /** Reorderthreshold */
  reorderThreshold?: number | null;
  /**
   * Isactive
   * @default true
   */
  isActive?: boolean;
}

/** InventoryItemListResponse */
export interface InventoryItemListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: InventoryItem[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** InventoryItemSummary */
export interface InventoryItemSummary {
  /** Itemid */
  itemId: number;
  /**
   * Purchasedqty
   * @default 0
   */
  purchasedQty?: number;
  /**
   * Purchasedcost
   * @default 0
   */
  purchasedCost?: number;
  /**
   * Soldqty
   * @default 0
   */
  soldQty?: number;
  /**
   * Soldrevenue
   * @default 0
   */
  soldRevenue?: number;
  /**
   * Givenqty
   * @default 0
   */
  givenQty?: number;
  /**
   * Rentedoutqty
   * @default 0
   */
  rentedOutQty?: number;
  /**
   * Onhand
   * @default 0
   */
  onHand?: number;
}

/** InventoryItemUpdate */
export interface InventoryItemUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Categoryid */
  categoryId?: number | null;
  /** Code */
  code?: string | null;
  /** Unit */
  unit?: string | null;
  /** Isconsumable */
  isConsumable?: boolean | null;
  /** Issellable */
  isSellable?: boolean | null;
  /** Isrentable */
  isRentable?: boolean | null;
  /** Defaultcost */
  defaultCost?: number | string | null;
  /** Defaultsaleprice */
  defaultSalePrice?: number | string | null;
  /** Defaultrentalrate */
  defaultRentalRate?: number | string | null;
  defaultRentalRateUnit?: RentalRateUnitEnum | null;
  /** Reorderthreshold */
  reorderThreshold?: number | null;
  /** Isactive */
  isActive?: boolean | null;
}

/** InventoryMovement */
export interface InventoryMovement {
  /** Movementid */
  movementId: number;
  /** Itemid */
  itemId: number;
  movementType: InventoryMovementTypeEnum;
  /** Quantity */
  quantity: number;
  /** Adjustmentsign */
  adjustmentSign?: number | null;
  /** Unitcost */
  unitCost?: number | null;
  /** Unitprice */
  unitPrice?: number | null;
  /** Rentalrate */
  rentalRate?: number | null;
  rentalRateUnit?: RentalRateUnitEnum | null;
  /** Rentalstart */
  rentalStart?: string | null;
  /** Rentalexpectedreturn */
  rentalExpectedReturn?: string | null;
  /** Rentalactualreturn */
  rentalActualReturn?: string | null;
  /** Parentmovementid */
  parentMovementId?: number | null;
  recipientType?: InventoryRecipientTypeEnum | null;
  /** Recipientid */
  recipientId?: number | null;
  /** Recipientname */
  recipientName?: string | null;
  /** Visitid */
  visitId?: number | null;
  /** Supplier */
  supplier?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Occurredat
   * @format date-time
   */
  occurredAt: string;
  /** Createdbyuserid */
  createdByUserId?: number | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Billingtransactionid */
  billingTransactionId?: number | null;
}

/** InventoryMovementCreate */
export interface InventoryMovementCreate {
  /** Itemid */
  itemId: number;
  movementType: InventoryMovementTypeEnum;
  /** Quantity */
  quantity: number | string;
  /** Adjustmentsign */
  adjustmentSign?: number | null;
  /** Unitcost */
  unitCost?: number | string | null;
  /** Unitprice */
  unitPrice?: number | string | null;
  /** Rentalrate */
  rentalRate?: number | string | null;
  rentalRateUnit?: RentalRateUnitEnum | null;
  /** Rentalstart */
  rentalStart?: string | null;
  /** Rentalexpectedreturn */
  rentalExpectedReturn?: string | null;
  /** Parentmovementid */
  parentMovementId?: number | null;
  recipientType?: InventoryRecipientTypeEnum | null;
  /** Recipientid */
  recipientId?: number | null;
  /** Recipientname */
  recipientName?: string | null;
  /** Visitid */
  visitId?: number | null;
  /** Supplier */
  supplier?: string | null;
  /** Notes */
  notes?: string | null;
  /** Occurredat */
  occurredAt?: string | null;
}

/** InventoryMovementListResponse */
export interface InventoryMovementListResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: InventoryMovement[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** RentalAvailabilityPoint */
export interface RentalAvailabilityPoint {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Free */
  free: number;
}

/** RentalAvailabilityResponse */
export interface RentalAvailabilityResponse {
  /** Itemid */
  itemId: number;
  /**
   * Owned
   * @default 0
   */
  owned?: number;
  /**
   * Freenow
   * @default 0
   */
  freeNow?: number;
  /** Nextfreedate */
  nextFreeDate?: string | null;
  /**
   * Points
   * @default []
   */
  points?: RentalAvailabilityPoint[];
}

/** RentalReturnRequest */
export interface RentalReturnRequest {
  /** Actual Return */
  actual_return?: string | null;
}

/**
 * Service
 * Model representing a Homecare Service offering.
 */
export interface Service {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
}

/**
 * ServiceCreate
 * Schema for creating a new service.
 */
export interface ServiceCreate {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
}

/**
 * ServicePackage
 * A persisted package, its contents and its derived pricing.
 *
 * ``contents_cost`` / ``contents_price`` are computed by the
 * ``service_package_pricing`` view and are never stored, so they cannot drift
 * from the contents. ``effective_price`` is what the package actually sells for
 * and ``price_source`` says where that came from: ``'package'`` when
 * :attr:`price` is set, ``'contents'`` when it is not.
 *
 * ``pattern`` is ``None`` for a simple package. That is a different claim from an
 * empty pattern: a simple package has no grid at all, where a repeated one with
 * ``times=[]`` is a grid nobody has drawn on yet. Collapsing the two would make
 * "is this a template?" unanswerable from the payload.
 */
export interface ServicePackage {
  /**
   * Name
   * Name of the package
   * @minLength 1
   */
  name: string;
  /**
   * Description
   * Detailed description of the package
   */
  description?: string | null;
  /**
   * Cost
   * Cost of the package in Euros. Derived from the contents when omitted.
   */
  cost?: number | null;
  /**
   * Price
   * Authoritative selling price of the package in Euros. When omitted the package is priced from its contents instead - see priceSource on the read model.
   */
  price?: number | null;
  /**
   * Commissionexempt
   * Whether the package is excluded from commission calculation. Null when the caller is not entitled to the package's internal economics - see redact_internal_costs.
   * @default false
   */
  commissionExempt?: boolean | null;
  /**
   * Isactive
   * Whether the package can be sold on new work. An inactive package is retired rather than deleted: it stops appearing in pickers but stays visible on the service request lines that already reference it, so history is preserved. Deleting a sold package fails anyway - service_request_lines.package_id is ON DELETE RESTRICT.
   * @default true
   */
  isActive?: boolean;
  /**
   * simple = a bag of services. repeated = those services placed on a weekly grid of untimed SLOTS, with visitCount visits. A repeated package's visits per week and visits per day are counts over its pattern - its cells, and its slot rows - and are never stored.
   * @default "simple"
   */
  kind?: ServicePackageKindEnum;
  /**
   * Visitcount
   * How many visits a repeated package includes. Also what 'price' denominates: price is the total for ALL visitCount visits, never per visit and never per week. Required for repeated, forbidden for simple.
   */
  visitCount?: number | null;
  /**
   * Weekscount
   * How many weeks a repeated package's weekly pattern repeats for. visit_count is derived from this and the pattern's visits per week and sent alongside it; required for repeated, forbidden for simple.
   */
  weeksCount?: number | null;
  /**
   * Pricepervisit
   * Informational selling price for one visit. Independent of price (the authoritative total for all visitCount visits) - optional for both kinds, and nothing derives one from the other.
   */
  pricePerVisit?: number | null;
  /**
   * Costpervisit
   * Informational cost for one visit. Independent of cost (the authoritative total) - optional for both kinds.
   */
  costPerVisit?: number | null;
  /** Packageid */
  packageId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /**
   * Services
   * @default []
   */
  services?: ServicePackageServiceDb[];
  /** The weekly grid. Present only for a repeated package; None for a simple one, which has no pattern rather than an empty one. */
  pattern?: ServicePackagePatternOutput | null;
  /**
   * Contentscost
   * Sum of units x member cost. Derived, never stored. units is quantity for a simple package; for a repeated one each member is weighted by its cell count, so this is what ONE WEEK of the pattern costs.
   */
  contentsCost?: number | null;
  /**
   * Contentsprice
   * Sum of units x member price, weighted by cell count for a repeated package - so this is one week of the pattern, while 'price' is the total for all visitCount visits. Derived, never stored.
   */
  contentsPrice?: number | null;
  /**
   * Effectivecost
   * cost when set, otherwise contentsCost
   */
  effectiveCost?: number | null;
  /**
   * Effectiveprice
   * price when set, otherwise contentsPrice
   */
  effectivePrice?: number | null;
  /**
   * Pricesource
   * 'package' when price is set, else 'contents'
   */
  priceSource?: string | null;
}

/**
 * ServicePackageCreate
 * Schema for creating a package together with its contents.
 */
export interface ServicePackageCreate {
  /**
   * Name
   * Name of the package
   * @minLength 1
   */
  name: string;
  /**
   * Description
   * Detailed description of the package
   */
  description?: string | null;
  /**
   * Cost
   * Cost of the package in Euros. Derived from the contents when omitted.
   */
  cost?: number | null;
  /**
   * Price
   * Authoritative selling price of the package in Euros. When omitted the package is priced from its contents instead - see priceSource on the read model.
   */
  price?: number | null;
  /**
   * Commissionexempt
   * Whether the package is excluded from commission calculation
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the package can be sold on new work. An inactive package is retired rather than deleted: it stops appearing in pickers but stays visible on the service request lines that already reference it, so history is preserved. Deleting a sold package fails anyway - service_request_lines.package_id is ON DELETE RESTRICT.
   * @default true
   */
  isActive?: boolean;
  /**
   * simple = a bag of services. repeated = those services placed on a weekly grid of untimed SLOTS, with visitCount visits. A repeated package's visits per week and visits per day are counts over its pattern - its cells, and its slot rows - and are never stored.
   * @default "simple"
   */
  kind?: ServicePackageKindEnum;
  /**
   * Visitcount
   * How many visits a repeated package includes. Also what 'price' denominates: price is the total for ALL visitCount visits, never per visit and never per week. Required for repeated, forbidden for simple.
   */
  visitCount?: number | null;
  /**
   * Weekscount
   * How many weeks a repeated package's weekly pattern repeats for. visit_count is derived from this and the pattern's visits per week and sent alongside it; required for repeated, forbidden for simple.
   */
  weeksCount?: number | null;
  /**
   * Pricepervisit
   * Informational selling price for one visit. Independent of price (the authoritative total for all visitCount visits) - optional for both kinds, and nothing derives one from the other.
   */
  pricePerVisit?: number | null;
  /**
   * Costpervisit
   * Informational cost for one visit. Independent of cost (the authoritative total) - optional for both kinds.
   */
  costPerVisit?: number | null;
  /**
   * Services
   * The package's contents. May be empty for a placeholder.
   */
  services?: ServicePackageServiceReq[];
  /** The weekly grid, for a repeated package. Required with kind=repeated and rejected with kind=simple. */
  pattern?: ServicePackagePatternInput | null;
}

/**
 * ServicePackagePattern
 * A package's weekly grid.
 *
 * The whole pattern is one value, replaced wholesale, for the reason
 * :attr:`ServicePackageUpdate.services` is: a cell's identity is its position in
 * the grid, so there is nothing stable to address in a partial patch, and giving
 * it one would mean a sub-resource API for marginal benefit.
 *
 * Cells nest under their slot rather than sitting in a flat list, because that is
 * the shape the grid already has on the client and it makes the entire pattern
 * one round trip in either direction.
 *
 * THE FIELD IS ``times`` AND THE ROWS ARE SLOTS. The name is the wire contract's,
 * matching ``WeekPattern.times`` in the client's ``authoring/weekModel.ts``, which
 * both the arrangement grid and this pattern are serialised from; the rows
 * themselves are :class:`ServicePackagePatternSlot` and carry no time. Renaming
 * the field would rename a request and response field in lockstep with the
 * client, which the table rename in ``20260810120000`` did not require - the
 * stored table has no such twin outside this repository.
 */
export interface ServicePackagePatternInput {
  /** Times */
  times?: ServicePackagePatternSlot[];
}

/**
 * ServicePackagePattern
 * A package's weekly grid.
 *
 * The whole pattern is one value, replaced wholesale, for the reason
 * :attr:`ServicePackageUpdate.services` is: a cell's identity is its position in
 * the grid, so there is nothing stable to address in a partial patch, and giving
 * it one would mean a sub-resource API for marginal benefit.
 *
 * Cells nest under their slot rather than sitting in a flat list, because that is
 * the shape the grid already has on the client and it makes the entire pattern
 * one round trip in either direction.
 *
 * THE FIELD IS ``times`` AND THE ROWS ARE SLOTS. The name is the wire contract's,
 * matching ``WeekPattern.times`` in the client's ``authoring/weekModel.ts``, which
 * both the arrangement grid and this pattern are serialised from; the rows
 * themselves are :class:`ServicePackagePatternSlot` and carry no time. Renaming
 * the field would rename a request and response field in lockstep with the
 * client, which the table rename in ``20260810120000`` did not require - the
 * stored table has no such twin outside this repository.
 */
export interface ServicePackagePatternOutput {
  /** Times */
  times?: ServicePackagePatternSlot[];
}

/**
 * ServicePackagePatternCell
 * One cell of the weekly grid: on this weekday, deliver this service.
 *
 * WEEKDAY IS MO=0 … SU=6 - dateutil's convention, this backend's own
 * ``_WEEKDAY_NUMBERS`` (``homecare.scheduling.recurrence``), rrule's, and the one
 * the client's ``DraftRecurrence.byweekday`` and ``ALL_WEEKDAYS`` already use.
 * NOT Postgres' ``EXTRACT(DOW)``, which is Sunday=0. An off-by-one here schedules
 * every visit of a month on the wrong day and nothing downstream notices - no
 * constraint is violated, no error is raised, the visits simply land on the wrong
 * dates. The bounds mirror ``service_package_pattern_cells_weekday_check``
 * (``CHECK (weekday BETWEEN 0 AND 6)``).
 *
 * ``service_id``, not ``package_service_id``: a caller composing a package knows
 * which services it is putting in, not what identity the member rows will be
 * given. The stored column is ``package_service_id``, so a write of this model has
 * to resolve the service to the package's member row, and must refuse a cell that
 * resolves to none - which is also why :func:`_validate_pattern_membership`
 * insists the contents travel with the pattern, so that refusal can happen against
 * the request rather than against stored state.
 */
export interface ServicePackagePatternCell {
  /**
   * Weekday
   * MO=0 … SU=6
   * @min 0
   * @max 6
   */
  weekday: number;
  /** Serviceid */
  serviceId: number;
}

/**
 * ServicePackagePatternSlot
 * One row of the weekly grid: a SLOT of the week, and the cells on it.
 *
 * A SLOT HAS NO TIME
 * ------------------
 * It is a POSITION in the day - slot 1, slot 2 - not an hour of it. A package is
 * a template for work that has not been scheduled: the client has not chosen
 * hours, so "two visits a day" is two slots rather than 09:00 and 10:00. The
 * hours are chosen later, once, by the coordinator building a real arrangement
 * from the template, and they are stored there - as the tz-aware
 * ``start_time``/``end_time`` of a service-request line slot, which hangs off a
 * dated line and so has a real instant to store.
 *
 * ``sort_order`` is therefore the whole content of a slot besides its cells, and
 * it carries a second meaning: HOW MANY SLOTS A PATTERN HAS IS THE PACKAGE'S
 * VISITS PER DAY, counted off :attr:`ServicePackagePattern.times` rather than
 * stored on the package, exactly as ``cell_count`` is its visits per week. Its
 * lower bound is this model's own rule, not a mirror of anything - the column is
 * a plain ``SMALLINT NOT NULL`` with no CHECK on it.
 */
export interface ServicePackagePatternSlot {
  /**
   * Sortorder
   * Display order within the pattern
   * @min 0
   */
  sortOrder: number;
  /** Cells */
  cells?: ServicePackagePatternCell[];
}

/**
 * ServicePackageServiceDb
 * A persisted package member, enriched with the service's name.
 *
 * ``name`` comes from the ``services`` join so a caller can render a package's
 * contents without a second round trip.
 */
export interface ServicePackageServiceDb {
  /** Serviceid */
  serviceId: number;
  /**
   * Quantity
   * @exclusiveMin 0
   * @default 1
   */
  quantity?: number;
  /** Packageserviceid */
  packageServiceId: number;
  /** Packageid */
  packageId: number;
  /** Name */
  name?: string | null;
}

/**
 * ServicePackageServiceReq
 * One member of a package: a service and how many of it.
 *
 * ``quantity`` is the whole point of this shape - "2x medication
 * administration" is one entry with ``quantity=2``, not two entries.
 */
export interface ServicePackageServiceReq {
  /** Serviceid */
  serviceId: number;
  /**
   * Quantity
   * @exclusiveMin 0
   * @default 1
   */
  quantity?: number;
}

/**
 * ServicePackageUpdate
 * Schema for patching a package. Every field optional.
 *
 * ``services`` replaces the package's contents wholesale rather than patching
 * them, matching how ``ServiceRequestLineUpdateReq.slots`` works: a member's
 * identity is its service_id, and partial patching would need its own
 * sub-resource API for marginal benefit. Omitting it leaves the contents alone;
 * sending ``[]`` empties them.
 *
 * ``pattern`` must be read the identical way: omitted has to leave the stored grid
 * alone and sent has to replace it wholesale, because that is what keeps a screen
 * which never loaded the pattern from emptying it by saving a name change. The
 * distinction only exists because the field is ``Optional`` with a ``None``
 * default, so ``None`` and ``times=[]`` are separable in the parsed request.
 *
 * Setting ``is_active`` to false is the supported way to retire a package that
 * has already been sold.
 */
export interface ServicePackageUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
  /** Commissionexempt */
  commissionExempt?: boolean | null;
  /** Isactive */
  isActive?: boolean | null;
  /** Services */
  services?: ServicePackageServiceReq[] | null;
  kind?: ServicePackageKindEnum | null;
  /** Visitcount */
  visitCount?: number | null;
  /** Weekscount */
  weeksCount?: number | null;
  /** Pricepervisit */
  pricePerVisit?: number | null;
  /** Costpervisit */
  costPerVisit?: number | null;
  /** Replaces the weekly grid wholesale. Omitted leaves the stored pattern alone; must be accompanied by services. */
  pattern?: ServicePackagePatternInput | null;
}

/**
 * ServicePackagesGetAllPaginationResponse
 * Response model for paginated retrieval of service packages.
 */
export interface ServicePackagesGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ServicePackage[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ServicePopulated
 * Service model enriched with its related ServiceType data.
 */
export interface ServicePopulated {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
  /** Model representing a type of service, stored in a separate table. */
  serviceType: ServiceType;
  /** Createdat */
  createdAt?: string | null;
}

/**
 * ServiceType
 * Model representing a type of service, stored in a separate table.
 */
export interface ServiceType {
  /**
   * Servicetypeid
   * Unique identifier for the service type (PK)
   */
  serviceTypeId: number;
  /**
   * Name
   * Name of the service type
   */
  name: string;
  /**
   * Description
   * Detailed description of the service type
   */
  description?: string | null;
  /** Createdat */
  createdAt?: string | null;
}

/**
 * ServiceTypeCreate
 * Schema for creating a new service type.
 */
export interface ServiceTypeCreate {
  /**
   * Name
   * Name of the service type
   */
  name: string;
  /** Description */
  description?: string | null;
}

/**
 * ServiceTypeUpdate
 * Schema for updating an existing service type.
 */
export interface ServiceTypeUpdate {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/** ServiceTypesGetAllPaginationResponse */
export interface ServiceTypesGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ServiceType[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/**
 * ServiceUpdate
 * Schema for updating an existing service.
 */
export interface ServiceUpdate {
  /** Name */
  name?: string | null;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId?: number | null;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   */
  isExternalService?: boolean | null;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation
   */
  commissionExempt?: boolean | null;
  /**
   * Isactive
   * Set false to retire the service without deleting it
   */
  isActive?: boolean | null;
}

/**
 * ServicesGetAllPopulatedPaginationResponse
 * Response model for paginated retrieval of populated services from the database.
 */
export interface ServicesGetAllPopulatedPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: ServicePopulated[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/services-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title services
 * @version 1.0.0
 * @baseUrl /api/v1/services-api/
 *
 *
 * Microservice for managing home care service types & services.
 *
 * ## Features
 * * Create, read, update, and delete service types
 * * Create, read, update, and delete services
 * * Maintain the service-package catalog: named bundles of services with a
 *   quantity for each, priced as a bundle or from their contents
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  services = {
    /**
     * @description Retrieve a paginated list of services with optional filters. Provide 'query' (min 3 chars) to perform free-text search across name, description, and service type name.
     *
     * @tags Services
     * @name ListServices
     * @summary Get services (list or search)
     * @request GET:/services
     * @secure
     */
    listServices: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 10000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
        /**
         * Caregiver Ids
         * Filter by caregiver ids
         */
        caregiver_ids?: number[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ServicesGetAllPopulatedPaginationResponse, HTTPValidationError | void>({
        path: `/services`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new service record
     *
     * @tags Services
     * @name CreateService
     * @summary Create new service
     * @request POST:/services
     * @secure
     */
    createService: (data: ServiceCreate, params: RequestParams = {}) =>
      this.request<ServicePopulated, void | HTTPValidationError>({
        path: `/services`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportServices
     * @summary Export the services list
     * @request POST:/services/export
     * @secure
     */
    exportServices: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/services/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicesTemplate
     * @summary Import template for the services list
     * @request GET:/services/import/template
     * @secure
     */
    importServicesTemplate: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/services/import/template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicesPreview
     * @summary Check an import of the services list without saving
     * @request POST:/services/import/preview
     * @secure
     */
    importServicesPreview: (data: BodyImportServicesPreview, params: RequestParams = {}) =>
      this.request<ImportReport, void | HTTPValidationError>({
        path: `/services/import/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicesCommit
     * @summary Import into the services list, all rows or none
     * @request POST:/services/import/commit
     * @secure
     */
    importServicesCommit: (data: BodyImportServicesCommit, params: RequestParams = {}) =>
      this.request<ImportReport, void | ImportReport | HTTPValidationError>({
        path: `/services/import/commit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a list of services associated with a specific service type ID
     *
     * @tags Services
     * @name ListServicesByType
     * @summary Get services by type ID
     * @request GET:/services/by-type/{service_type_id}
     * @secure
     */
    listServicesByType: (
      serviceTypeId: number,
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ServicesGetAllPopulatedPaginationResponse, void | HTTPValidationError>({
        path: `/services/by-type/${serviceTypeId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific service by its ID
     *
     * @tags Services
     * @name GetServiceById
     * @summary Get service by ID
     * @request GET:/services/{service_id}
     * @secure
     */
    getServiceById: (serviceId: number, params: RequestParams = {}) =>
      this.request<ServicePopulated, void | HTTPValidationError>({
        path: `/services/${serviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing service's information
     *
     * @tags Services
     * @name UpdateService
     * @summary Update service
     * @request PUT:/services/{service_id}
     * @secure
     */
    updateService: (serviceId: number, data: ServiceUpdate, params: RequestParams = {}) =>
      this.request<Service, void | HTTPValidationError>({
        path: `/services/${serviceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a service record by ID
     *
     * @tags Services
     * @name DeleteService
     * @summary Delete service
     * @request DELETE:/services/{service_id}
     * @secure
     */
    deleteService: (serviceId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/services/${serviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name HealthCheck
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  serviceTypes = {
    /**
     * @description Free text query; if not given return all; if given (>3 chars) searches
     *
     * @tags Service Types
     * @name ListServiceTypes
     * @summary Get service types (list or search)
     * @request GET:/service-types
     * @secure
     */
    listServiceTypes: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ServiceTypesGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/service-types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new service type record
     *
     * @tags Service Types
     * @name CreateServiceType
     * @summary Create new service type
     * @request POST:/service-types
     * @secure
     */
    createServiceType: (data: ServiceTypeCreate, params: RequestParams = {}) =>
      this.request<ServiceType, void | HTTPValidationError>({
        path: `/service-types`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportServiceTypes
     * @summary Export the service_types list
     * @request POST:/service-types/export
     * @secure
     */
    exportServiceTypes: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/service-types/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific service type by its ID
     *
     * @tags Service Types
     * @name GetServiceTypeById
     * @summary Get service type by ID
     * @request GET:/service-types/{service_type_id}
     * @secure
     */
    getServiceTypeById: (serviceTypeId: number, params: RequestParams = {}) =>
      this.request<ServiceType, void | HTTPValidationError>({
        path: `/service-types/${serviceTypeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing service type's information
     *
     * @tags Service Types
     * @name UpdateServiceType
     * @summary Update service type
     * @request PUT:/service-types/{service_type_id}
     * @secure
     */
    updateServiceType: (serviceTypeId: number, data: ServiceTypeUpdate, params: RequestParams = {}) =>
      this.request<ServiceType, void | HTTPValidationError>({
        path: `/service-types/${serviceTypeId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a service type record by ID
     *
     * @tags Service Types
     * @name DeleteServiceType
     * @summary Delete service type
     * @request DELETE:/service-types/{service_type_id}
     * @secure
     */
    deleteServiceType: (serviceTypeId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/service-types/${serviceTypeId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  servicePackages = {
    /**
     * @description Retrieve a paginated list of service packages, each with its contents (service + quantity) and its derived pricing. Provide 'query' (min 3 chars) to search name and description.
     *
     * @tags Service Packages
     * @name ListServicePackages
     * @summary Get service packages (list or search)
     * @request GET:/service-packages
     * @secure
     */
    listServicePackages: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Is Active
         * Filter by the retirement flag. Omit for both, so a retired package can still be found in order to reactivate it.
         */
        is_active?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ServicePackagesGetAllPaginationResponse, HTTPValidationError>({
        path: `/service-packages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a package and its contents in one transaction. Each entry in 'services' carries a quantity, so '2x medication administration' is one entry with quantity 2. Omit 'price' to price the package from its contents instead of a lump bundle price. A kind=repeated package additionally carries 'visitCount' and a 'pattern' - the weekly grid saying which service is delivered on which weekday, in which SLOT of the day, with weekday MO=0 to SU=6. A slot carries NO TIME, only a 'sortOrder' and its cells: a package is a template, so 'two visits a day' is two slots and the hours are chosen later, when the template is applied to an arrangement. How many visits a day the package means is therefore the number of slots, and how many a week is the number of cells; neither is sent and neither is stored. Every cell must name a service that is also in 'services'. On a repeated package 'price' is the total for ALL visitCount visits, never per visit and never per week, while the derived 'contentsPrice' is what one week of the pattern is worth - the two are denominated differently and are not comparable. kind=simple accepts neither 'pattern' nor 'visitCount'. A repeated package also requires 'weeksCount' (how many weeks the pattern repeats for; 'visitCount' is derived from it and the pattern together). 'pricePerVisit' and 'costPerVisit' are optional informational figures for either kind, independent of 'price'/'cost'.
     *
     * @tags Service Packages
     * @name CreateServicePackage
     * @summary Create a service package
     * @request POST:/service-packages
     * @secure
     */
    createServicePackage: (data: ServicePackageCreate, params: RequestParams = {}) =>
      this.request<ServicePackage, void | HTTPValidationError>({
        path: `/service-packages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportServicePackages
     * @summary Export the service_packages list
     * @request POST:/service-packages/export
     * @secure
     */
    exportServicePackages: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/service-packages/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicePackagesTemplate
     * @summary Import template for the service_packages list
     * @request GET:/service-packages/import/template
     * @secure
     */
    importServicePackagesTemplate: (params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/service-packages/import/template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicePackagesPreview
     * @summary Check an import of the service_packages list without saving
     * @request POST:/service-packages/import/preview
     * @secure
     */
    importServicePackagesPreview: (data: BodyImportServicePackagesPreview, params: RequestParams = {}) =>
      this.request<ImportReport, void | HTTPValidationError>({
        path: `/service-packages/import/preview`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportServicePackagesCommit
     * @summary Import into the service_packages list, all rows or none
     * @request POST:/service-packages/import/commit
     * @secure
     */
    importServicePackagesCommit: (data: BodyImportServicePackagesCommit, params: RequestParams = {}) =>
      this.request<ImportReport, void | ImportReport | HTTPValidationError>({
        path: `/service-packages/import/commit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the package with its contents and derived pricing.
     *
     * @tags Service Packages
     * @name GetServicePackage
     * @summary Get one service package
     * @request GET:/service-packages/{package_id}
     * @secure
     */
    getServicePackage: (packageId: number, params: RequestParams = {}) =>
      this.request<ServicePackage, void | HTTPValidationError>({
        path: `/service-packages/${packageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Patches the package's own fields. Supplying 'services' replaces its contents wholesale. Set 'isActive' false to RETIRE a package that has already been sold - deleting one is refused, because a service request line records what was sold. 'pattern' replaces the weekly grid wholesale and is treated exactly as 'services' is: omitting it leaves the stored grid alone, so a screen that never loaded the pattern cannot empty it by saving a name change. Sending 'pattern' REQUIRES sending 'services' too, because every cell names a service and that name has to resolve against the contents in the same request rather than against stored state the caller has not seen. Changing 'kind' to simple CLEARS everything only a repeated package carries: the stored pattern and 'visitCount' are both discarded, whether or not the patch mentions them. On a repeated package 'price' is the total for all 'visitCount' visits, and the pattern's rows are untimed slots - 'sortOrder' plus cells, no times. A repeated package also requires 'weeksCount' (how many weeks the pattern repeats for; 'visitCount' is derived from it and the pattern together). 'pricePerVisit' and 'costPerVisit' are optional informational figures for either kind, independent of 'price'/'cost'.
     *
     * @tags Service Packages
     * @name UpdateServicePackage
     * @summary Update a service package
     * @request PATCH:/service-packages/{package_id}
     * @secure
     */
    updateServicePackage: (packageId: number, data: ServicePackageUpdate, params: RequestParams = {}) =>
      this.request<ServicePackage, void | HTTPValidationError>({
        path: `/service-packages/${packageId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes the package and cascades its contents. REFUSED with 409 for any package referenced by a service request line: a line records what was sold, so the FK is ON DELETE RESTRICT. Retire such a package with PATCH {"isActive": false} instead.
     *
     * @tags Service Packages
     * @name DeleteServicePackage
     * @summary Delete a service package that has never been sold
     * @request DELETE:/service-packages/{package_id}
     * @secure
     */
    deleteServicePackage: (packageId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/service-packages/${packageId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  inventory = {
    /**
     * @description Free text query; if not given return all; if given (>3 chars) searches
     *
     * @tags Inventory Categories
     * @name ListInventoryCategories
     * @summary Get inventory categories (list or search)
     * @request GET:/inventory/categories
     * @secure
     */
    listInventoryCategories: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<InventoryCategoryListResponse, HTTPValidationError>({
        path: `/inventory/categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Categories
     * @name CreateInventoryCategory
     * @summary Create Category
     * @request POST:/inventory/categories
     * @secure
     */
    createInventoryCategory: (data: InventoryCategoryCreate, params: RequestParams = {}) =>
      this.request<InventoryCategory, HTTPValidationError>({
        path: `/inventory/categories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportInventoryCategories
     * @summary Export the inventory_categories list
     * @request POST:/inventory/categories/export
     * @secure
     */
    exportInventoryCategories: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/inventory/categories/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Categories
     * @name UpdateInventoryCategory
     * @summary Update Category
     * @request PUT:/inventory/categories/{category_id}
     * @secure
     */
    updateInventoryCategory: (categoryId: number, data: InventoryCategoryUpdate, params: RequestParams = {}) =>
      this.request<InventoryCategory, HTTPValidationError>({
        path: `/inventory/categories/${categoryId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Categories
     * @name DeleteInventoryCategory
     * @summary Delete Category
     * @request DELETE:/inventory/categories/{category_id}
     * @secure
     */
    deleteInventoryCategory: (categoryId: number, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/inventory/categories/${categoryId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name ListInventoryItems
     * @summary List Items
     * @request GET:/inventory/items
     * @secure
     */
    listInventoryItems: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /** Category Id */
        category_id?: number | null;
        /** Capability */
        capability?: string | null;
        /** Query */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'name,-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<InventoryItemListResponse, HTTPValidationError>({
        path: `/inventory/items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name CreateInventoryItem
     * @summary Create Item
     * @request POST:/inventory/items
     * @secure
     */
    createInventoryItem: (data: InventoryItemCreate, params: RequestParams = {}) =>
      this.request<InventoryItem, HTTPValidationError>({
        path: `/inventory/items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportInventoryItems
     * @summary Export the inventory_items list
     * @request POST:/inventory/items/export
     * @secure
     */
    exportInventoryItems: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/inventory/items/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name GetInventoryItem
     * @summary Get Item
     * @request GET:/inventory/items/{item_id}
     * @secure
     */
    getInventoryItem: (itemId: number, params: RequestParams = {}) =>
      this.request<InventoryItem, HTTPValidationError>({
        path: `/inventory/items/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name UpdateInventoryItem
     * @summary Update Item
     * @request PUT:/inventory/items/{item_id}
     * @secure
     */
    updateInventoryItem: (itemId: number, data: InventoryItemUpdate, params: RequestParams = {}) =>
      this.request<InventoryItem, HTTPValidationError>({
        path: `/inventory/items/${itemId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name DeleteInventoryItem
     * @summary Delete Item
     * @request DELETE:/inventory/items/{item_id}
     * @secure
     */
    deleteInventoryItem: (itemId: number, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError>({
        path: `/inventory/items/${itemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Items
     * @name GetInventoryItemSummary
     * @summary Get Item Summary
     * @request GET:/inventory/items/{item_id}/summary
     * @secure
     */
    getInventoryItemSummary: (itemId: number, params: RequestParams = {}) =>
      this.request<InventoryItemSummary, HTTPValidationError>({
        path: `/inventory/items/${itemId}/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Movements
     * @name CreateInventoryMovement
     * @summary Create Movement
     * @request POST:/inventory/movements
     * @secure
     */
    createInventoryMovement: (data: InventoryMovementCreate, params: RequestParams = {}) =>
      this.request<InventoryMovement, HTTPValidationError>({
        path: `/inventory/movements`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Movements
     * @name ListInventoryMovements
     * @summary List Movements
     * @request GET:/inventory/movements
     * @secure
     */
    listInventoryMovements: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /** Item Id */
        item_id?: number | null;
        /** Movement Type */
        movement_type?: string | null;
        /** Recipient Type */
        recipient_type?: string | null;
        /** Recipient Id */
        recipient_id?: number | null;
        /** Visit Id */
        visit_id?: number | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<InventoryMovementListResponse, HTTPValidationError>({
        path: `/inventory/movements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Free text query; if not given return all; if given (>3 chars) searches the recipient and the rented item's name
     *
     * @tags Inventory Rentals
     * @name ListInventoryRentals
     * @summary Get rentals (list or search)
     * @request GET:/inventory/rentals
     * @secure
     */
    listInventoryRentals: (
      query?: {
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Status
         * @default "active"
         * @pattern ^(active|overdue|all)$
         */
        status?: string;
        /**
         * Query
         * Free text query; if not given return all; if given (>3 chars) searches
         */
        query?: string | null;
        /**
         * Sort
         * JSON:API sorting, e.g. '-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
        /** Item Id */
        item_id?: number | null;
        /**
         * From
         * Keep rentals still out on or after this date
         */
        from?: string | null;
        /**
         * To
         * Keep rentals started on or before this date
         */
        to?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ActiveRentalListResponse, HTTPValidationError>({
        path: `/inventory/rentals`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Exports
     * @name ExportInventoryRentals
     * @summary Export the inventory_rentals list
     * @request POST:/inventory/rentals/export
     * @secure
     */
    exportInventoryRentals: (data: ExportRequest, params: RequestParams = {}) =>
      this.request<ExportStarted, void>({
        path: `/inventory/rentals/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Rentals
     * @name ReturnInventoryRental
     * @summary Return Rental
     * @request POST:/inventory/rentals/{rental_out_id}/return
     * @secure
     */
    returnInventoryRental: (rentalOutId: number, data: RentalReturnRequest, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/inventory/rentals/${rentalOutId}/return`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inventory Rentals
     * @name GetInventoryAvailability
     * @summary Get Availability
     * @request GET:/inventory/availability
     * @secure
     */
    getInventoryAvailability: (
      query: {
        /** Item Id */
        item_id: number;
        /**
         * From
         * @format date
         */
        from: string;
        /**
         * To
         * @format date
         */
        to: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RentalAvailabilityResponse, HTTPValidationError>({
        path: `/inventory/availability`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
